module.exports = __webpack_public_path__ + "static/media/sf_4.a68bb23a.svg";